<template>
    <li class="c-header-nav-link-item" :class="{ 'c-header-nav-link-item--active': isActive(navLink) }">
        <router-link
            v-if="!navLink.isExternal"
            @click.native="closeNav"
            :to="navLink.path"
            :title="navLink.title"
            class="c-header-nav-link-item__router t-t1-heavy"
            exact
            itemprop="url"
        >
            <span class="c-header-nav-link-item__router__span">
                {{ navLink.title }} <icon class="c-header-nav-link-item__router__span__icon" icon="arrow-in-circle"
            /></span>
        </router-link>
        <a
            v-else
            :href="navLink.path"
            target="_blank"
            rel="noopener noreferrer"
            class="c-header-nav-link-item__router t-t1-heavy"
        >
            <span class="c-header-nav-link-item__router__span">
                {{ navLink.title }} <icon class="c-header-nav-link-item__router__span__icon" icon="arrow-in-circle"
            /></span>
        </a>
    </li>
</template>

<script>
import Icon from "objects/Icon";
export default {
    components: {
        Icon
    },
    props: {
        navLink: {
            type: Object,
            required: true
        }
    },
    methods: {
        isActive(route) {
            const current = this.$route;
            return current.path.startsWith(route.path);
        },
        closeNav() {
            this.$store.commit("navigation/TOGGLE_NAV", false);
        }
    }
};
</script>

<style lang="scss">
.c-header-nav-link-item {
    display: flex;
    width: 100%;

    &__router {
        @include transition(0.3s ease all);
        @include outLinedTitle($color-white);
        color: rgba(255, 255, 255, 0);

        overflow: hidden;

        padding-left: var(--grid-gutter);
        margin-left: calc(0px - var(--grid-gutter));

        @media #{$breakpoint-horizontal} {
            padding-left: var(--grid-gutter-double);
            margin-left: 0px;
            max-width: 1100px;
        }

        .c-header-nav-link-item--active &,
        &:hover {
            color: rgba(255, 255, 255, 1);
        }

        &__span {
            @include transform(translate(0px, 50px)); // for the stagger animation when the user open the nav */
            position: relative;
            display: block;
            opacity: 0;
            padding: 5px 0px; // make sure the font is not cropped

            @media #{$breakpoint-horizontal} {
                padding: 15px 100px 15px 0px; // make sure the font is not cropped
            }

            &:before {
                @include transition(0.3s ease all);
                @include transform(translate(-30px));
                content: " ";
                position: absolute;
                height: 100%;
                background-color: $color-bright;
                left: calc(0px - var(--grid-gutter));
                width: 8px;
                opacity: 0;
                top: 0px;
                /* TODO: User &root instead */
                .c-header-nav-link-item:hover &,
                .c-header-nav-link-item--active & {
                    @include transform(translate(0px));
                    opacity: 1;
                }
                @media #{$breakpoint-horizontal} {
                    /* minor adjustement so if fits looks a bit better with the line weight */
                    height: calc(100% - 1rem);
                    top: 0.25rem;
                    left: calc(0px - var(--grid-gutter-double));
                }
            }

            &__icon {
                @include transition(0.3s ease all);
                display: none;
                @media #{$breakpoint-horizontal} {
                    @include transform(translate(-10px));
                    display: flex;
                    position: absolute;
                    top: calc(50% - 45px);
                    max-width: 80px;
                    max-height: 80px;
                    opacity: 0;
                    right: 0px;

                    .c-header-nav-link-item__router:hover &,
                    .c-header-nav-link-item--active & {
                        @include transform(translate(0px));
                        opacity: 1;
                    }
                }
            }
        }
    }
}
</style>
